import {UI} from "../../../../../stem-core/src/ui/UIBase";

import {iFrameUserDataService} from "../../../../services/IFrameUserDataService";
import {InlineUserDashboardSection} from "../components/InlineUserDashboardSection";
import {Messages} from "../../../../Messages";
import {MerchantButton} from "../../../../common/MerchantButton";
import {iFrameMerchantService} from "../../../../services/IframeMerchantService";
import {InlineUserDashboardTab} from "./InlineUserDashboardTab";
import {InlineUserDashboardPaymentsTable} from "../components/InlineUserDashboardPaymentsTable";
import {PaymentStore} from "../../../../../client/state/PaymentStore";
import {CARD_SECTION_STATE, PaymentMethodController} from "../../../flows/PaymentMethodController.js";
import {PaymentMethodStore} from "../../../../../client/state/PaymentMethodStore";
import {Router} from "../../../../../stem-core/src/ui/Router";
import {
    ADDRESS_PANEL_URL,
    INLINE_EDIT_SUBSCRIPTION_URLS,
    INLINE_USER_DASHBOARD_URLS,
    PAYMENT_DETAILS_PANEL_URL, SUBSCRIPTION_PLAN_PANEL_URL
} from "../../../PanelConstants";
import {ADDRESS_SECTION_STATE} from "../../panels/address/AddressPanel";
import {SUBSCRIBE_PLAN_STATE, SubscriptionPlanController} from "../../../flows/SubscriptionPlanController.js";
import {SubscriptionApplyPolicy, SubscriptionStore} from "../../../../../client/state/SubscriptionStore";
import {MessageElement} from "../../../../widget/ui/MessageElement";
import {autoredraw} from "../../../../../stem-core/src/decorators/AutoRedraw";
import {UserAddressStore} from "../../../../../client/state/UserAddressStore";
import {UsingBlinkDefaultPaymentMethod} from "../../../../common/UsingBlinkDefaultPaymentMethod";
import {TNR_ALIAS} from "../../../../../blink-sdk/Constants";
import {updateSubscription} from "../prompt-panels/InlineUserDashboardSubscriptionChangeConfirmPanel";
import {SocialAccountProvider, SocialAccountStore} from "../../../../../client/state/SocialAccountStore";
import {InlineUserDashboardCDSAccountSection} from "../components/InlineUserDashboardCDSSection";
import {startSubscriptionFlow} from "../../../flows/FlowEntrypoint.js";
import {getPaymentMethodEmptySubscriptionMessage} from "../../../../common/MessagingUtils.js";
import {Controller} from "../../../flows/Controller.js";
import {SubscriptionFlowHandler} from "../../../flows/SubscriptionFlowHandler.js";
import {AddressController} from "../../../flows/AddressController.js";
import {BasePanelPage} from "../../../PanelPage.jsx";
import {iFrameState} from "../../../../services/IFrameState.js";
import {PaymentMethodDescription} from "../../../../common/PaymentMethodDescription.jsx";


function CDSSubscriptionAccountSection(subscription) {
    if (!iFrameMerchantService.isMerchant(TNR_ALIAS)) {
        return null;
    }
    // TODO When we'll have multiple CDS merchants, there might be a separate CDS social account. Match it by the merchant's publication code.
    const cdsSocialAccount = SocialAccountStore.find(socialAccount => socialAccount.provider === SocialAccountProvider.CDS && socialAccount.extraData?.handlesSubscriptions);
    return InlineUserDashboardCDSAccountSection(cdsSocialAccount);
}


// TODO @cleanup rename this shit
@autoredraw(PaymentMethodStore, UserAddressStore, SubscriptionStore)
export class InlineUserDashboardSubscriptionTab extends InlineUserDashboardTab {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            title: Messages.inlineUserDashboardSubscription,
        }
    }

    editPlan() {
        const subscription = iFrameUserDataService.getActiveSubscription();

        const onSelectSuccess = async () => {
            await Controller.subscriptionPlan.fetchPrices(Controller.address?.selectedAddress);
            Router.changeURL(INLINE_USER_DASHBOARD_URLS.subscriptionChangeConfirm);
        }

        Controller.address = new AddressController({
            addressSectionState: ADDRESS_SECTION_STATE.chooseAddress,
            selectedAddress: subscription.getShippingAddress(),
            onSelectCancel: () => Router.back(),
            onSelectSuccess,
            continueLabel: Messages.continue,
        });
        Controller.subscriptionPlan = new SubscriptionPlanController({
            subscriptionPlanState: SUBSCRIBE_PLAN_STATE.editSubscription,
            selectedOffer: null,
            onSelectSuccess: async () => {
                const {selectedOffer} = Controller.subscriptionPlan;
                if (selectedOffer) {
                    await Controller.subscriptionPlan.fetchPrices(Controller.address.selectedAddress);
                    if (selectedOffer.shouldCollectAddress()) {
                        Router.changeURL(ADDRESS_PANEL_URL);
                        return;
                    }
                }
                await onSelectSuccess();
            },
            onSelectCancel: () => Router.back(),
            applyPolicy: SubscriptionApplyPolicy.NEXT_BILLING_CYCLE,
            discountCode: subscription.getDiscount()?.getCode() || null,
        });
        Router.changeURL(SUBSCRIPTION_PLAN_PANEL_URL);
    }

    editAddress() {
        const subscription = iFrameUserDataService.getActiveSubscription();
        const onSelectSuccess = async () => {
            await Controller.subscriptionPlan.fetchPrices(Controller.address?.selectedAddress);
            Router.changeURL(INLINE_USER_DASHBOARD_URLS.subscriptionChangeConfirm);
        };
        Controller.address = new AddressController({
            addressSectionState: ADDRESS_SECTION_STATE.chooseAddress,
            selectedAddress: subscription.getShippingAddress(),
            onSelectCancel: () => Router.back(),
            onSelectSuccess,
            continueLabel: Messages.continue,
        });
        Controller.subscriptionPlan = new SubscriptionPlanController({
            subscriptionPlanState: SUBSCRIBE_PLAN_STATE.editSubscription,
            selectedOffer: null,
            applyPolicy: SubscriptionApplyPolicy.INSTANTLY,
            discountCode: subscription.getDiscount()?.getCode() || null,
        });
        Router.changeURL(ADDRESS_PANEL_URL);
    }

    editPaymentMethod() {
        const subscription = iFrameUserDataService.getActiveSubscription();
        Controller.paymentMethod = new PaymentMethodController({
            cardSectionState: CARD_SECTION_STATE.chooseCard,
            entry: subscription,
            initialPaymentMethod: subscription.getPaymentMethod(),
            selectedPaymentMethod: subscription.getPaymentMethod(),
            savePaymentMethod: true,
            getChooseCardButtonLabel: () => Messages.updatePaymentMethod,
            getPayWithAddedCardButtonLabel: () => Messages.updatePaymentMethod,
            getScope: () => PaymentMethodStore.Scope.PRIVATE,
            onSelectSuccess: async () => {
                await updateSubscription({
                    preferredPaymentMethodId:
                        subscription.getPaymentMethod() === Controller.paymentMethod.selectedPaymentMethod ?
                            null : Controller.paymentMethod.selectedPaymentMethod.id,
                });
            },
            onSelectCancel: () => {
                Router.back();
            }
        });
        Router.changeURL(PAYMENT_DETAILS_PANEL_URL);
    }

    cancelSubscription(subscription) {
        SubscriptionFlowHandler.subscriptionToCancel = subscription;
        Controller.subscriptionPlan = new SubscriptionPlanController({
            subscriptionPlanState: SUBSCRIBE_PLAN_STATE.editSubscription,
            selectedOffer: null,
            onSelectCancel: () => Router.back(),
            onCancel: () => Router.back(),
        });
        Router.changeURL(INLINE_EDIT_SUBSCRIPTION_URLS.cancel);
    }

    renderSubscription() {
        const {styleSheet} = this;
        const subscription = iFrameUserDataService.getActiveSubscription();

        if (!subscription) {
            return [
                <InlineUserDashboardSection titleMessage={Messages.subscriptionPlanTitle}
                                            headerTitle={Messages.activeSubscription}>
                    <MessageElement className={styleSheet.textSection}
                                    message={Messages.notSubscribedToMerchant}
                                    args={[iFrameMerchantService.getMerchant().name]} />
                    <MerchantButton label={Messages.subscribe} className={styleSheet.button}
                                    onClick={() => startSubscriptionFlow()}/>
                </InlineUserDashboardSection>,
            ];
        }

        const preferredPaymentMethod = subscription.getPaymentMethod();
        const planActions = iFrameMerchantService.isCDSPaymentMethod() ? {} : {
            actionMessage: Messages.change,
            actionFunction: () => this.editPlan(),
        };
        const paymentMethodActions = iFrameMerchantService.isCDSPaymentMethod() ? {} : {
            actionMessage: Messages.edit,
            actionFunction: () => this.editPaymentMethod(),
        };

        return [
            <InlineUserDashboardSection headerTitle={Messages.activeSubscription} hideSeparator
                                        titleMessage={Messages.subscriptionPlanTitle} {...planActions}>
                <MessageElement className={styleSheet.textSection} message={Messages.subscribedCurrentPlan}
                                args={[subscription.coverage.name, subscription.formatPrice()]} />
                {iFrameMerchantService.isMerchant(TNR_ALIAS) &&
                    <MessageElement className={styleSheet.textSection} message={Messages.tnrDashboardPlanMessage}/>}
                {iFrameMerchantService.isMerchant(TNR_ALIAS) ? null : this.renderCancelButton(subscription)}
            </InlineUserDashboardSection>,

            subscription.getShippingAddress() &&
                <InlineUserDashboardSection
                    titleMessage={Messages.inlineAddressSectionTitle}
                    actionMessage={Messages.edit}
                    actionFunction={() => {
                        iFrameState.iframeParams.hasStepIndicator = false;
                        this.editAddress();
                    }}
                    hideSeparator
                >
                    <div>{subscription.getShippingAddress().getRecipientName()}</div>
                    <div>{subscription.getShippingAddress()}</div>
                </InlineUserDashboardSection>,

            <InlineUserDashboardSection titleMessage={Messages.paymentMethodTitle} {...paymentMethodActions}>
                {
                    preferredPaymentMethod ?
                        <PaymentMethodDescription paymentMethod={subscription.getPaymentMethod()} /> : (
                            iFrameUserDataService.hasPrimaryPaymentMethod() && !iFrameMerchantService.isCDSPaymentMethod() ?
                                [
                                    <UsingBlinkDefaultPaymentMethod/>,
                                    // TODO: This message is not correct in some cases, make something less stupid!
                                    <MessageElement className={styleSheet.textSection} message={Messages.paymentMethodCharge}
                                                    args={[subscription.getPrice(), subscription.billingPlan.getCycleDuration(true)]}/>
                                ] :
                                <div className={styleSheet.cardDetails}>
                                    <div>{getPaymentMethodEmptySubscriptionMessage(subscription)}</div>
                                </div>
                        )
                }

            </InlineUserDashboardSection>,
            CDSSubscriptionAccountSection(subscription),
        ];
    }

    renderPaymentHistory() {
        if (iFrameMerchantService.isMerchant(TNR_ALIAS)) {
            return null;
        }
        return <InlineUserDashboardSection headerTitle={Messages.paymentHistory}>
            <InlineUserDashboardPaymentsTable resourceType={PaymentStore.ResourceType.SUBSCRIPTION}/>
        </InlineUserDashboardSection>;
    }

    renderCancelButton(subscription) {
        return subscription.isActive() && !subscription.isActiveButCanceled() ?
            <div className={this.styleSheet.cancel} onClick={() => this.cancelSubscription(subscription)}>
                {Messages.cancelSubscription}
            </div> : null;
    }

    renderGiftedSubscriptions() {
        const {styleSheet} = this;
        const giftSentActiveSubscriptions = iFrameUserDataService.getGiftSentActiveSubscriptions();
        if (!giftSentActiveSubscriptions.length) {
            return null;
        }
        return giftSentActiveSubscriptions.map((s, i) =>
        <InlineUserDashboardSection titleMessage={Messages.subscriptionPlan}
                                    hideSeparator={i !== giftSentActiveSubscriptions.length - 1}
                                    {...(i ? {} : {headerTitle: Messages.giftSubscription})}>
            <MessageElement className={styleSheet.textSection} message={Messages.giftSubscriptionText}
                            args={[s.user.getEmail(), s.coverage.name, s.formatPrice()]}/>
            {this.renderCancelButton(s)}
        </InlineUserDashboardSection>);
    }

    render() {
        return [
            this.renderSubscription(),
            this.renderGiftedSubscriptions(),
            this.renderPaymentHistory(),
        ];
    }
}

export class SubscriptionDetailsPage extends BasePanelPage {
    render() {
        return <InlineUserDashboardSubscriptionTab />
    }
}